import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.user.game,
    (game) => {
        return {
            game
        }
    }
)